// Copyright (c) StrangeBee 2024

import { ListItemsPerPageType } from '@Constants/pagination';
import { useState } from 'react';

export interface PaginationInput {
    page: number;
    itemsPerPage: ListItemsPerPageType;
}

export interface UsePaginationReturn {
    page: number;
    itemsPerPage: ListItemsPerPageType;
    setPagination: React.Dispatch<React.SetStateAction<PaginationInput>>;
}

const usePagination = (itemsPerPageDefaultValue: ListItemsPerPageType = 10): UsePaginationReturn => {
    const [{ page, itemsPerPage }, setPagination] = useState<PaginationInput>({
        page: 0,
        itemsPerPage: itemsPerPageDefaultValue,
    });

    return { page, itemsPerPage, setPagination };
};

export default usePagination;
